module.exports = __webpack_public_path__ + "static/vscode-server-running-2098795743e26a55a5f96df8c2a59cad.png";